(ns manatee.admin.queue.subs
  "App. DB subscriptions for the admin. queue tab."
  (:require [manatee.admin.queue.app-db :as queue-db]
            [medley.core :as medley]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::queue-configurations
 (fn queue-configurations
   [db _]
   (queue-db/get-queue-configs db)))

(rf/reg-sub
 ::selected-queue-config-id
 (fn selected-queue-config-id
   [db _]
   (queue-db/get-selected-queue-config-id db)))

(rf/reg-sub
 ::selected-queue-config
 :<- [::selected-queue-config-id]
 :<- [::queue-configurations]
 (fn selected-queue-config
   [[selected-id configs] _]
   (medley/find-first #(= selected-id
                          (:id %))
                      configs)))

(rf/reg-sub
 ::list-view?
 (fn list-view?
   [db _]
   (queue-db/list-view? db)))
